function t(o) {
  if (typeof Symbol < "u" && o[Symbol.iterator] != null || o["@@iterator"] != null)
    return Array.from(o);
}
export {
  t as default
};
//# sourceMappingURL=iterableToArray.mjs.map
